module.exports = __webpack_public_path__ + "static/media/Logo.bb9cb724.svg";